/**
 * JavaScript Utility - format/number
 * @author 서명환 <mhseo@ulalalab.com>
 */
import isEmpty from '../isEmpty';
import { escapeRegex, repeat } from '../string';

function number(v, formatString) {
  if (!formatString) {
    return v;
  }

  if (isEmpty(v) || Number.isNaN(v)) {
    return '';
  }

  const comma = ',';
  const decimalSeparator = '.';
  const formatPattern = /[\d,.#]+/;

  let precision = 0;
  let splitFormats = [];
  let trimTrailingZeroes = null;

  if (formatString.substr(formatString.length - 2) === '/i') {
    formatString = formatString.substr(0, formatString.length - 2);
    splitFormats = formatString
      .replace(new RegExp(`[^\\d\\${decimalSeparator}#]`, 'g'), '')
      .split(decimalSeparator);
  } else {
    splitFormats = formatString.replace(/[^\d.#]/g, '').split(decimalSeparator);
  }

  if (splitFormats.length > 2) {
    throw new Error(
      `[utils.format.number] Invalid number format, should have no more than 1 decimal (value: ${v}, formatString: ${formatString})`
    );
  }

  const absVal = Math.abs(v);

  let trailingZeroes = null;

  if (splitFormats.length === 2) {
    precision = splitFormats[1].length;
    trimTrailingZeroes = splitFormats[1].match(/#+$/);

    if (trimTrailingZeroes) {
      trailingZeroes = new RegExp(
        `${escapeRegex(decimalSeparator)}*0{0,${trimTrailingZeroes[0].length}}$`
      );
    }
  }

  let fNum = absVal.toFixed(precision);

  if (formatString.includes(comma)) {
    let parts = [];

    if (precision) {
      parts = fNum.split(decimalSeparator);
      fNum = parts[0];
    }

    if (absVal >= 1000) {
      const thousands = [];

      for (let i = 0, { length: j } = fNum, n = j % 3 || 3; i < j; i += n) {
        if (i !== 0) {
          n = 3;
        }

        thousands.push(fNum.substr(i, n));
      }

      fNum = thousands.join(comma);
    }

    if (precision) {
      fNum += [decimalSeparator, parts[1]].join('');
    }
  }

  if (v < 0 && fNum !== (precision ? `0.${repeat(0, precision)}` : '0')) {
    fNum = `-${fNum}`;
  }

  if (trimTrailingZeroes) {
    fNum = fNum.replace(trailingZeroes, '');
  }

  return formatString.replace(formatPattern, '')
    ? formatString.replace(formatPattern, fNum)
    : fNum;
}

export default number;
